import { useCallback } from 'react';

import { api, FirstSteps } from '@shared/api';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useResources(id?: string) {
  const queryClient = useQueryClient();

  const { data: firstSteps } = useQuery({
    queryKey: ['dashboard.getUserFirstSteps'],
    queryFn: () => api.endpoints.getFirstSteps().then((e) => e.data),
    staleTime: 1000 * 60 * 5,
    suspense: true,
  });

  const { mutate: dismiss, isLoading } = useMutation({
    mutationKey: ['dashboard.getUserFirstSteps', id],
    mutationFn: (steps: FirstSteps[]) =>
      api.endpoints.postDismissFirstSteps({
        data: { steps },
      }),
    onSuccess: (_response, steps) => {
      queryClient.setQueryData<FirstSteps[]>(['dashboard.getUserFirstSteps'], (currentSteps) => {
        if (!currentSteps) {
          return [];
        }

        const dismissedStepIds = new Set(steps.map((step) => step));

        return currentSteps.filter((step) => !dismissedStepIds.has(step));
      });
    },
  });

  const dismissAll = useCallback(() => {
    if (firstSteps) {
      dismiss(firstSteps);
    }
  }, [dismiss, firstSteps]);

  return {
    dismiss,
    firstSteps,
    isLoading,
    dismissAll,
  };
}
